import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fullCard', 'halfCard', 'planTypeField'];
  static values = {
    initialPlanType: String,
    halfDisabled: Boolean,
  };

  // Button enable/disable is owned by submit-gate on the form; this controller
  // just toggles the plan-type cards and announces the change via
  // account-plan-type:changed, which submit-gate listens for to enable the button.
  connect() {
    this.currentPlanType = this.initialPlanTypeValue || 'full';
  }

  selectFull() {
    this._select('full');
  }

  selectHalf(event) {
    if (this.halfDisabledValue) {
      event?.preventDefault();
      event?.stopPropagation();
      return;
    }
    this._select('half');
  }

  _select(planType) {
    if (planType === this.currentPlanType) return;
    this.currentPlanType = planType;

    if (this.hasPlanTypeFieldTarget) {
      this.planTypeFieldTarget.value = planType;
    }

    this._toggleActiveCard(planType);
    this._dispatchPlanTypeChanged(planType);
  }

  _dispatchPlanTypeChanged(planType) {
    window.dispatchEvent(
      new CustomEvent('account-plan-type:changed', {
        detail: { planType },
      })
    );
  }

  _toggleActiveCard(planType) {
    if (this.hasFullCardTarget) {
      this.fullCardTarget.classList.toggle(
        'm-plan-option--selected',
        planType === 'full'
      );
    }
    if (this.hasHalfCardTarget) {
      this.halfCardTarget.classList.toggle(
        'm-plan-option--selected',
        planType === 'half'
      );
    }
  }
}
